import { render, staticRenderFns } from "./UiToast.vue?vue&type=template&id=a6e4572c"
import script from "./UiToast.vue?vue&type=script&lang=js"
export * from "./UiToast.vue?vue&type=script&lang=js"
import style0 from "./UiToast.vue?vue&type=style&index=0&id=a6e4572c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports